import React, { Fragment } from 'react';
import { Pagination, ScrollTo } from 'react-instantsearch/dom';
import { Grid, Column } from '../../grid';
import Article from '../../../containers/article';
import {
  NotFoundWrapper,
  NotFoundHeading,
  PaginationWrapper,
  ScrollToWrapper,
} from './style';
import GlassesIcon from '../../../images/glassesIcon';
import { ConnectedStateResults } from '../../algoliawrapper';

const EmptySearch = ({ text }) => (
  <NotFoundWrapper>
    <GlassesIcon width={120} height={100} />
    <NotFoundHeading>{text}</NotFoundHeading>
  </NotFoundWrapper>
);

const Hits = () => (
  <Fragment>
    <ConnectedStateResults>
      {({ hits, hasHits, searching }) => {
        return (
          <Fragment>
            {!hits ? (
              <EmptySearch text="Artikel werden geladen." />
            ) : hits && hits.length ? (
              <ScrollToWrapper hasHits={hasHits}>
                <ScrollTo>
                  <Grid>
                    {hits.map(item => {
                      return (
                        <Column key={item.articleID}>
                          <Article searching={searching} item={item} />
                        </Column>
                      );
                    })}
                  </Grid>
                  <PaginationWrapper>
                    <Pagination padding={1} />
                  </PaginationWrapper>
                </ScrollTo>
              </ScrollToWrapper>
            ) : (
              <EmptySearch text="Zu Ihrer Suche konnten leider keine Treffer gefunden werden." />
            )}
          </Fragment>
        );
      }}
    </ConnectedStateResults>
  </Fragment>
);

export default Hits;



// WEBPACK FOOTER //
// ./src/components/views/shop/hits.js